export default {
  // ヘッダーの件数表示用
  setTotalCountFlag (state: {[key:string]: boolean}, payload: boolean) {
    state.totalCountFlag = payload
  }
}
